import React from "react";
import { useLocation } from "react-router-dom";
import { Phone } from "lucide-react";
import { business } from "../mock";

export default function FloatingCall() {
  const { pathname } = useLocation();

  // Hide on the quote page, show everywhere else
  if (pathname === "/quote") return null;

  return (
    <a
      href={business.phoneHref}
      aria-label={`Call ${business.phone}`}
      className="md:hidden fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-brand-teal text-white shadow-xl shadow-brand-teal/30 transition-all duration-300 hover:bg-brand-tealdark active:scale-95"
    >
      <span className="absolute inline-flex h-full w-full rounded-full bg-brand-teal opacity-40 animate-ping-soft" />
      <Phone className="relative h-6 w-6" strokeWidth={2.2} />
    </a>
  );
}
